import React from 'react';
import { Typography, Box, Chip, Paper, Accordion, AccordionSummary, AccordionDetails, useMediaQuery, useTheme } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const LimitedTierlistHeader = ({ totalCards, filteredCards, currentPage, totalPages }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box textAlign="center" mb={3}>
            <Typography
                variant="h3"
                component="h1"
                sx={{
                    fontWeight: 700,
                    fontFamily: "Futura",
                    background: 'linear-gradient(135deg, #ffffff, #c4b5fd)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    mb: 2
                }}
            >
                Limited Tierlist
            </Typography>
            <Typography
                variant="h6"
                color="text.secondary"
                sx={{ mb: 2 }}
            >
                Odkryj najlepsze karty do formatu Limited w Disney Lorcana. Najedź na podgląd karty, aby zobaczyć ją w pełnym rozmiarze.
            </Typography>

            {/* Instrukcja jak czytać tier listę */}
            <Paper sx={{
                backgroundColor: 'rgba(17, 24, 39, 0.8)',
                border: '1px solid rgba(76, 29, 149, 0.3)',
                mb: 3,
                maxWidth: 800,
                mx: 'auto'
            }}>
                <Accordion sx={{
                    backgroundColor: 'transparent',
                    color: 'white',
                    '&:before': { display: 'none' },
                    boxShadow: 'none'
                }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: 'rgb(196, 181, 253)' }} />}
                        sx={{
                            '& .MuiAccordionSummary-content': {
                                justifyContent: 'center'
                            }
                        }}
                    >
                        <Typography variant="h6" sx={{ color: 'rgb(196, 181, 253)', fontWeight: 600 }}>
                            Jak czytać Tier Listę?
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ textAlign: 'left', px: 3, pb: 3 }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <Typography variant="body1" sx={{ color: 'white', lineHeight: 1.6 }}>
                                W ramach Tier Listy karty podzieliliśmy na:
                            </Typography>

                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, pl: 2 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography variant="body1" sx={{ color: 'rgb(245, 158, 11)', fontWeight: 600 }}>
                                        ★★★★★
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'white' }}>
                                        bomby - karty wygrywające grę, które warto brać bez względu na krzywą inka
                                    </Typography>
                                </Box>

                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography variant="body1" sx={{ color: 'rgb(245, 158, 11)', fontWeight: 600 }}>
                                        ★★★★☆
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'white' }}>
                                        dobre karty
                                    </Typography>
                                </Box>

                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography variant="body1" sx={{ color: 'rgb(245, 158, 11)', fontWeight: 600 }}>
                                        ★★★☆☆
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'white' }}>
                                        solidne karty
                                    </Typography>
                                </Box>

                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography variant="body1" sx={{ color: 'rgb(245, 158, 11)', fontWeight: 600 }}>
                                        ★★☆☆☆
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'white' }}>
                                        wypełniacze - warto brać żeby wypełnić krzywą inka
                                    </Typography>
                                </Box>

                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography variant="body1" sx={{ color: 'rgb(245, 158, 11)', fontWeight: 600 }}>
                                        ★☆☆☆☆
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'white' }}>
                                        słabe karty - których chcemy unikać, ale czasami nie mamy wyboru
                                    </Typography>
                                </Box>

                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography variant="body1" sx={{ color: 'rgb(245, 158, 11)', fontWeight: 600 }}>
                                        ☆☆☆☆☆
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'white' }}>
                                        niegrywalne karty znacząco pogarszające talię
                                    </Typography>
                                </Box>
                            </Box>

                            <Typography variant="body2" sx={{ color: 'rgb(156, 163, 175)', mt: 2, lineHeight: 1.6 }}>
                                <strong>Pamiętaj o własnej ocenie!</strong> Nie podążaj ślepo za tier listą.
                                Oceny kart pisane są w próżni, ale podczas draftowania wiele kart będzie się dopełniać wzajemnie.
                                Ten set ma dużo synergii - Puppy, akcje niebędące piosenkami, iluzje czy wsparcie dla Lady Kluck.
                            </Typography>
                        </Box>
                    </AccordionDetails>
                </Accordion>
            </Paper>

            {/* Stats */}
            {!isMobile && (
                <Box display="flex" justifyContent="center" gap={3} flexWrap="wrap" mb={3}>
                    <Chip
                        label={`${totalCards} wszystkich kart`}
                        sx={{
                            backgroundColor: 'rgba(76, 29, 149, 0.2)',
                            color: 'white',
                            border: '1px solid rgba(76, 29, 149, 0.3)'
                        }}
                    />
                    <Chip
                        label={`${filteredCards} przefiltrowanych kart`}
                        sx={{
                            backgroundColor: 'rgba(76, 29, 149, 0.2)',
                            color: 'white',
                            border: '1px solid rgba(76, 29, 149, 0.3)'
                        }}
                    />
                    <Chip
                        label={`Strona ${currentPage} z ${totalPages}`}
                        sx={{
                            backgroundColor: 'rgba(76, 29, 149, 0.2)',
                            color: 'white',
                            border: '1px solid rgba(76, 29, 149, 0.3)'
                        }}
                    />
                </Box>
            )}
        </Box>
    );
};

export default LimitedTierlistHeader; 